<template>
  <Widget
    :title="title"
    :tooltip="tooltip"
    :loading="loading"
    :action-handler="actionHandler"
    title-type="bold"
  >
    <div class="widget-body">
      <div class="value">{{ formattedValue | number }}</div>
      <v-tooltip bottom max-width="400px" v-if="showIncreaseIndicator">
        <template v-slot:activator="{ on }">
          <div v-on="on">
            <IncreaseIndicator :value="increaseValue" />
          </div>
        </template>
        <span>
          {{ $t("message.dashboard.widgetTooltip.comparedToLast30Days") }}
        </span>
      </v-tooltip>
    </div>
  </Widget>
</template>

<script>
import Widget from "@/components/Dashboard/base/Widget";
import IncreaseIndicator from "@/components/Dashboard/base/IncreaseIndicator";

export default {
  name: "DashboardValueWidget",
  components: {
    Widget,
    IncreaseIndicator
  },
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: [Number, String],
      required: true
    },
    increaseValue: {
      type: Number,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    actionHandler: {
      type: Function,
      default: () => void 0
    },
    showIncreaseIndicator: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    title() {
      return this.name
        ? this.$t(`message.dashboard.widgetTitle.${this.name}`)
        : "";
    },
    tooltip() {
      return this.name
        ? this.$t(`message.dashboard.widgetTooltip.${this.name}`)
        : "";
    },
    formattedValue() {
      return `${this.value}`.replace(".", ",");
    }
  }
};
</script>

<style lang="scss" scoped>
.widget-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .value {
    color: $text;
    font-weight: bold;
    @include font-size(40px);
    line-height: 49px;
    margin-bottom: $spacing;
  }
}
</style>
